import { PageHeader } from "@/components/PageHeader";

export default function MaterialRequestPage() {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <PageHeader title="자재요청" />

      <main className="flex-1 p-6">
        <div className="container mx-auto">
          <p className="text-gray-600 dark:text-gray-400">
            This is material-request page
          </p>
        </div>
      </main>
    </div>
  );
}
